import { useState, useEffect, useCallback } from 'react';
import { validate } from '@/utils/validators';
import { institutionSchema } from './institution.schema';
import type { institution } from '../userFormModal/types.props';
import type { parsedApiError } from '@/types/api/errors.api';
import type { institutionFormData } from './types.props';

export const initialFormState: institutionFormData = {
    name: '',
};

export const useInstitutionForm = (initialData?: institution) => {
    const [formData, setFormData] = useState<institutionFormData>(initialFormState);
    const [formErrors, setFormErrors] = useState<parsedApiError | null>(null);
    const isEditMode = Boolean(initialData);

    useEffect(() => {
        if (initialData) {
            setFormData({ name: initialData.name });
        } else {
            setFormData(initialFormState);
        }
    }, [initialData]);

    const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setFormErrors(null);
        setFormData({ name: e.target.value });
    }, []);

    const validateForm = useCallback(() => {
        setFormErrors(null);
        const validationErrors = validate(formData, institutionSchema);
        if (Object.keys(validationErrors).length > 0) {
            const errorPayload: parsedApiError = {
                generalMessage: "Por favor, corrija los errores del formulario.",
                fieldErrors: validationErrors,
                code: 'client_validation_error'
            };
            setFormErrors(errorPayload);
            return false;
        }
        return true;
    }, [formData]);

    return {
        formData,
        formErrors,
        setFormErrors,
        isEditMode,
        handleInputChange,
        validateForm,
    };
};
